import { render, staticRenderFns } from "./pricePlanList.vue?vue&type=template&id=164747a8&scoped=true"
import script from "./pricePlanList.vue?vue&type=script&lang=js"
export * from "./pricePlanList.vue?vue&type=script&lang=js"
import style0 from "./pricePlanList.vue?vue&type=style&index=0&id=164747a8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164747a8",
  null
  
)

export default component.exports